import gql from 'graphql-tag';

import { MarketingMaterialAssetDetails } from '../fragments/marketing-material-assets';

export const marketingMaterialAssetCreate = gql`
  mutation marketingMaterialAssetCreate(
    $input: MarketingMaterialAssetCreateInput!
  ) {
    marketingMaterialAssetCreate(input: $input) {
      marketing_material_asset {
        ...MarketingMaterialAssetDetails
      }
    }
  }
  ${MarketingMaterialAssetDetails}
`;

export const marketingMaterialAssetUpdate = gql`
  mutation marketingMaterialAssetUpdate(
    $input: MarketingMaterialAssetUpdateInput!
  ) {
    marketingMaterialAssetUpdate(input: $input) {
      marketing_material_asset {
        ...MarketingMaterialAssetDetails
        album_folders(slice: { limit: 999 }) {
          total
          records {
            id
            album_folder {
              id
            }
          }
        }
      }
    }
  }
  ${MarketingMaterialAssetDetails}
`;

export const marketingMaterialAssetDelete = gql`
  mutation marketingMaterialAssetDelete(
    $input: MarketingMaterialAssetDeleteInput!
  ) {
    marketingMaterialAssetDelete(input: $input) {
      success
    }
  }
`;
